/**
 * Asynchronously loads the component for CancellationRefund
 */

import { lazyLoad } from "utils/loadable";

export const CancellationRefund = lazyLoad(
  () => import("./index"),
  (module) => module.CancellationRefund
);
